import React from 'react';

// Terms of Service page for Virtual Hardhat
// TODO: Add real legal content and review for SaaS, compliance, and liability.

function TermsOfService() {
  return (
    <div className="max-w-3_xl mx-auto py-16 px-4">
      <h1 className="text-3_xl font-bold mb-6 text-yellow-500">Terms of Service</h1>
      <p className="mb-4 text-gray-700">
        This is a placeholder for the Virtual Hardhat Terms of Service. Please review and update
        with your legal team before launch.
      </p>
      <ul className="list-disc pl-6 text-gray-600">
        <li>
          Use of this platform is subject to compliance with all applicable laws and regulations.
        </li>
        <li>Virtual Hardhat is not liable for any incidents or non-compliance on jobsites.</li>
        <li>Contact support@virtual-hardhat.com for any legal questions.</li>
      </ul>
      <div className="mt-8 text-sm text-gray-400">Last updated: June 2024</div>
    </div>
  );
}

export default TermsOfService;
